import i18n from "i18next";
import { platformToast } from "$root/notification-system/toast";
import type { Instrument } from "../../const";
import type { SizingMessage } from "./sizingMessage";
import { describeSizingMessage, instrumentLabel, isClearedToZero } from "./sizingMessage";

/**
 * Toasts what Cold War said about `row` as its answer lands. It names the instrument, because the
 * user may have moved on to another row by then.
 */
export function toastSizingMessage(row: Instrument, sizingMessage: SizingMessage): void {
	platformToast({
		children: describeSizingMessage(i18n.t, instrumentLabel(row), sizingMessage),
		severity: isClearedToZero(sizingMessage) ? "warning" : "info",
		icon: "Portfolio",
	});
}
